module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Success":"Le rôle du compte a été changé avec succès."},"fr":{"Success":"Le rôle du compte a été changé avec succès."}}')
  delete Component.options._Ctor
}
